
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["couponUselog_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M959.73 33.33H63.33c-16.57 0-30 13.43-30 30v896.39c0 16.57 13.43 30 30 30h292.54v-60H93.33V93.33h836.39v268.08h60V63.33c.01-16.57-13.42-30-29.99-30z"}}),_c('path',{attrs:{"d":"M421.02 421.41v568.32h538.71c16.57 0 30-13.43 30-30V421.41H421.02zm508.71 508.32H481.02V733.88H858c16.57 0 30-13.43 30-30s-13.43-30-30-30H481.02V481.41h448.71v448.32z"}}),_c('path',{attrs:{"d":"M671.34 606.05h186.65c16.57 0 30-13.43 30-30s-13.43-30-30-30H671.34c-16.57 0-30 13.43-30 30 0 16.56 13.43 30 30 30zm186.65 195.67H671.34c-16.57 0-30 13.43-30 30s13.43 30 30 30h186.65c16.57 0 30-13.43 30-30s-13.43-30-30-30zM547.33 606.05h17.92c16.57 0 30-13.43 30-30s-13.43-30-30-30h-17.92c-16.57 0-30 13.43-30 30 0 16.56 13.43 30 30 30zm17.92 195.67h-17.92c-16.57 0-30 13.43-30 30s13.43 30 30 30h17.92c16.57 0 30-13.43 30-30s-13.43-30-30-30zm268.84-577.85c0-16.57-13.43-30-30-30H222.04c-16.57 0-30 13.43-30 30s13.43 30 30 30h582.05c16.57 0 30-13.43 30-30zM335.02 415.83c0-16.57-13.43-30-30-30h-82.98c-16.57 0-30 13.43-30 30s13.43 30 30 30h82.98c16.56 0 30-13.43 30-30zm0 191.97c0-16.57-13.43-30-30-30h-82.98c-16.57 0-30 13.43-30 30s13.43 30 30 30h82.98c16.56 0 30-13.43 30-30zm-30 161.96h-82.98c-16.57 0-30 13.43-30 30s13.43 30 30 30h82.98c16.57 0 30-13.43 30-30s-13.44-30-30-30z"}})])
          )
        }
      }
    